<template>
  <div
    class="big-video"
    :data-theme="getRouteName !== 'home' ? false : getCity === 'amsterdam' ? 'pink' : getCity === 'new-york' ? 'azure' : 'blue'"
    data-cont="small"
  >
    <div
      class="video"
    >
      <div class="video-player">
        <video
          crossorigin="*"
          autoplay="autoplay"
          playsinline="true"
          webkit-playsinline="true"
          loop
          muted
        >
          <source :src="data.videoUrl" type="video/mp4" />
        </video>
      </div>
    </div>

    <div class="video__caption">
      <div class="video__cta">
        <BaseButtonFilled
          :data="Object.assign(data, { routerLink: data.url.startsWith('/') })"
          v-if="data.content !== undefined"
        />
      </div>
      <p v-if="data.subtitle !== ''" v-html="data.subtitle" js-anim="text">{{ data.subtitle }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseButtonFilled from '@/components/BaseButtonFilled.vue';


export default {
  name: 'bigVideo',

  components: {
    BaseButtonFilled,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters(['getRouteName', 'getCity']),
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/utils";

.big-video {
  position: relative;
  width: 100%;

  .ui-container {
    position: relative;
    width: 100%;
  }

  .video {
    position: relative;
    width: 100%;
    margin: 40px 0 25px;

    .video-player {
      position: relative;
      overflow: hidden;

      @include aspect-ratio(10, 7);

      @include mq($until: mobile, $and: $is-portrait) {
        @include aspect-ratio(1, 1);
      }

      @include mq($from: mobileL, $until: ipadP) {
        @include aspect-ratio(10, 5);
      }

      @include mq(ipadL) {
        @include aspect-ratio(21, 9);
      }
    }

    @include mq(mobileL) {
      margin: 80px 0 25px;
    }

    video {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      object-fit: cover;
    }

    &__caption {
      display: flex;
      flex-flow: row wrap;
      align-items: baseline;

      @include mq(mobileL) {
        justify-content: space-between;
      }

      p {
        order: 1;
        padding: 0 20px;
        @include mq(mobileL) {
          padding-left: 0;
          padding-right: 20px;
        }
      }
    }

    &__cta {
      margin: 40px 0 0 0;
      flex: 0 0 100%;
      order: 2;

      @include mq(mobileL) {
        flex: auto;
        margin: 0;
        order: 0;
        text-align: left;
      }
    }
  }
}
</style>
